import { Component, HostBinding } from '@angular/core';

/**
 * @ngdoc component
 * @name ApKeyComponent
 * @deprecated In favor of plain CSS `dl.ap-definition-list>dt+dd`
 */
@Component({
    selector: 'dt',
    templateUrl: './key.component.html'
})
export class ApKeyComponent {
    @HostBinding('class.keys-values__key') public hostClass = true;
}
